import React, { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { toast } from "sonner"
import axiosInstance from "../../utils/axios/axiosConfig"
import ProductSidebar from "./ProductModal"
import ProductDetails from "./ProductDetails"
import FilterModal from "./FilterModal"
import { DeleteModal } from '../../components'
import {
  Search,
  Filter,
  Plus,
  Import,
  Star,
  Award,
  Gift,
  Edit,
  Trash2,
  ChevronLeft,
  ChevronRight,
  Eye,
  Pencil,
} from "lucide-react"

function Products() {
  const [products, setProducts] = useState([])
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const [sidebarMode, setSidebarMode] = useState("create")
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [productId, setProductId] = useState(null)

  const [brands, setBrands] = useState([])
  const [categories, setCategories] = useState([])

  const [filters, setFilters] = useState({
    search: "",
    categories: [],
    brands: [],
    status: [],
    priceRange: { min: 0, max: 1000 },
    isTopSeller: false,
    isFeatured: false,
    isSpecialOffer: false,
  })

  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  useEffect(() => {
    getProducts()
    getBrands()
    getCategories()
  }, [done])

  const getBrands = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(`/brands/search`)
      const responseData = response.data
      if (responseData) {
        setBrands(responseData.data)
      }
      setLoading(false)
    } catch (error) {
      toast.error(error.response.data.message)
      setLoading(false)
    }
  }

  const getCategories = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(`/categories/search`)
      const responseData = response.data
      if (responseData) {
        setCategories(responseData.data)
      }
      setLoading(false)
    } catch (error) {
      toast.error(error.response.data.message)
      setLoading(false)
    }
  }

  const getProducts = async (page = 1) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(`/products/search?page=${page}&per_page=10`, filters)
      const responseData = response.data
      if (responseData) {
        setProducts(responseData.data)
        setCurrentPage(responseData.current_page)
        setTotalPages(responseData.last_page)
      }
      setLoading(false)
    } catch (error) {
      toast.error(error.response.data.message)
      setLoading(false)
    }
  }

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
    getProducts(1)
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      getProducts(currentPage + 1)
    }
  }

  const handlePrevious = () => {
    if (currentPage > 1) {
      getProducts(currentPage - 1)
    }
  }

  const openSidebar = (mode, product = null) => {
    setSidebarMode(mode)
    setSelectedProduct(product)
    setIsSidebarOpen(true)
  }

  const closeSidebar = () => {
    setIsSidebarOpen(false)
    setSelectedProduct(null)
  }

  const openDetails = (product) => {
    setSelectedProduct(product)
    setIsDetailsOpen(true)
  }

  const closeDetails = () => {
    setIsDetailsOpen(false)
    setSelectedProduct(null)
  }



  return (
    <div className="mx-auto p-5">
      <div className="flex lg:justify-between gap-3 lg:items-center flex-col lg:flex-row mb-6">
        <div className="flex flex-col items-start gap-1">

          <h1 className="text-xl font-semibold text-neutral-900 dark:text-white">Products</h1>
          <p className="text-sm text-neutral-600 ">Manage products here .</p>

        </div>

        <div className="flex flex-col lg:flex-row gap-2">
          <div className="flex-1 max-w-md relative">
            <input
              type="text"
              placeholder="Search products..."
              className="pl-10 pr-4 py-2 lg:w-64 w-full text-sm border border-neutral-200 dark:border-neutral-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-neutral-800 dark:text-white"
              value={filters.search}
              onChange={(e) => handleFilterChange({ ...filters, search: e.target.value })}
            />
            <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-neutral-400" />
          </div>
          {/* <button
            onClick={() => setIsFilterModalOpen(true)}
            className=" inline-flex items-center px-4 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-200 rounded-lg hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700"
          >
            <Filter className="w-4 h-4 mr-2" />
            Filters
          </button>
          <button className="inline-flex items-center px-4 py-2 text-sm font-medium text-neutral-700 bg-white border border-neutral-200 rounded-lg hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700">
            <Import className="w-4 h-4 mr-2" />
            Import
          </button> */}
          <button
            onClick={() => openSidebar("create")}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#2B2B35] rounded-lg hover:bg-cyan-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <Plus className="w-4 h-4 mr-2" />
            Add Product
          </button>
        </div>
      </div>


      <div className="flex flex-col mt-4">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">

            <div className="overflow-hidden border border-neutral-200 dark:border-neutral-700 md:rounded-lg">
              <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-700">
                <thead className="bg-neutral-50 h-14 dark:bg-neutral-800">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-4 text-sm  text-start font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                    >
                      Product
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-sm  text-start font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                    >
                      SKU
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-sm  text-start font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                    >
                      Price
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-sm  text-start font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                    >
                      Stock
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-sm  text-start font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-4 text-sm  text-start font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-neutral-200">
                  {loading
                    ? Array(5)
                      .fill(0)
                      .map((_, index) => (
                        <tr key={index}>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <div className="h-10 w-10 bg-neutral-200 rounded-lg"></div>
                              <div className="ml-4">
                                <div className="h-4 bg-neutral-200 rounded w-32"></div>
                                <div className="h-3 bg-neutral-200 rounded w-24 mt-2"></div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="h-4 bg-neutral-200 rounded w-20"></div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="h-4 bg-neutral-200 rounded w-16"></div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="h-4 bg-neutral-200 rounded w-12"></div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="h-4 bg-neutral-200 rounded w-16"></div>
                          </td>
                          <td className="px-6 py-4  whitespace-nowrap text-right">
                            <div className="h-8 bg-neutral-200 rounded w-24 ml-auto"></div>
                          </td>
                        </tr>
                      ))
                    : products.map((product) => (
                      <tr key={product.id} className="hover:bg-neutral-50">
                        <td className="px-6  py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <img
                              src={product.images[0] || "/placeholder.svg"}
                              alt={product.name}
                              className="h-10 w-10 rounded-lg object-cover"
                            />
                            <div className="ml-4 text-start">
                              <div className="text-sm font-medium text-neutral-900">{product.name}</div>
                              <div className="text-sm text-neutral-500">{product.category?.name}</div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4  text-start whitespace-nowrap">
                          <div className="text-sm  text-neutral-500">{product.sku}</div>
                        </td>
                        <td className="px-6 py-4 text-start whitespace-nowrap">
                          <div className="text-sm text-neutral-900">${Number.parseFloat(product.price).toFixed(2)}</div>
                        </td>
                        <td className="px-6 py-4 text-start whitespace-nowrap">
                          <div className="text-sm text-neutral-500">{product.stock}</div>
                        </td>
                        <td className="px-6 py-4 text-start whitespace-nowrap">
                          <span
                            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${product.is_active ? "bg-green-100 text-green-800" : "bg-neutral-100 text-neutral-800"
                              }`}
                          >
                            {product.is_active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="px-6 py-4  gap-3  whitespace-nowrap text-right text-sm font-medium">
                          <div className="flex jsutify-start gap-3 items-center">
                            <button onClick={() => openDetails(product)} className="flex justify-center hover:scale-110 transition-all duration-400 items-center   rounded-md hover:bg-neutral-200 text-neutral-500"
                            >
                              <Eye size={16} />
                            </button>
                            <button
                              onClick={() => openSidebar("edit", product)}
                              className="flex justify-center hover:scale-110 transition-all duration-400 items-center   rounded-md hover:bg-neutral-200 text-neutral-500"
                            >
                              <Pencil size={16} />
                            </button>
                            <button onClick={() => {
                              setProductId(product.id)
                              setDeleteModal(true)
                            }} className="flex justify-center hover:scale-110 transition-all duration-400 items-center   rounded-md hover:bg-neutral-200 text-neutral-500"
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>

                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <div className="text-sm text-neutral-700">
          Showing page {currentPage} of {totalPages}
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={handlePrevious}
            disabled={currentPage === 1 || loading}
            className={`px-4 py-2 border rounded-md flex items-center ${currentPage === 1 || loading
              ? "bg-neutral-100 text-neutral-400 cursor-not-allowed"
              : "bg-white text-neutral-700 hover:bg-neutral-50"
              }`}
          >
            <ChevronLeft className="w-5 h-5 mr-1" />
            Previous
          </button>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages || loading}
            className={`px-4 py-2 border rounded-md flex items-center ${currentPage === totalPages || loading
              ? "bg-neutral-100 text-neutral-400 cursor-not-allowed"
              : "bg-white text-neutral-700 hover:bg-neutral-50"
              }`}
          >
            Next
            <ChevronRight className="w-5 h-5 ml-1" />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isSidebarOpen && (
          <ProductSidebar
            productData={selectedProduct}
            onClose={closeSidebar}
            setDone={setDone}
            done={done}
            brands={brands}
            categories={categories}
          />
        )}
        {isDetailsOpen && <ProductDetails product={selectedProduct} onClose={closeDetails} />}
        {isFilterModalOpen && (
          <FilterModal
            filters={filters}
            setFilters={handleFilterChange}
            onClose={() => setIsFilterModalOpen(false)}
            categories={categories}
            brands={brands}
          />
        )}
      </AnimatePresence>

      <DeleteModal setDeleteId={setProductId} open={deleteModal} setOpen={setDeleteModal} DeleteId={productId} Model='products' setDone={setDone} setLoding={setLoading} done={done} />

    </div>
  )
}

export default Products

